// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

const ACCOUNT_ADMIN = 'accountadmin';
const SHOP_ADMIN = 'shopadmin';
const SUPER_ADMIN = 'superadmin';
const WARRANTY_ADMIN = 'warrantyadmin';

export const isAccountAdmin = ({ roleName = '' }: { roleName: string }) => {
    return roleName.toLowerCase() === ACCOUNT_ADMIN;
};
export const isShopAdmin = ({ roleName = '' }: { roleName: string }) => {
    return roleName.toLowerCase() === SHOP_ADMIN;
};

export const isUserSuperAdmin = ({ roleName = '' }: { roleName: string }) => {
    return roleName.toLowerCase() === SUPER_ADMIN;
};

export const isWarrantyAdmin = ({ roleName = '' }: { roleName: string }) => {
    return roleName.toLowerCase() === WARRANTY_ADMIN;
};
